import type { RootState } from "@/app/store";
import { Estabelecimento } from "@/contexts/cadastro/estabelecimento/model/Estabelecimento";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EstabelecimentoState {
  items: Estabelecimento[];
  synced: boolean;
}

const initialState: EstabelecimentoState = {
  items: [],
  synced: false,
};

const estabelecimentoSlice = createSlice({
  name: "ESTABELECIMENTO",
  initialState,
  reducers: {
    sync: {
      reducer: (state, action: PayloadAction<{ items: Estabelecimento[] }>) => {
        state.items = action.payload.items;
        state.synced = true;
      },
      prepare: (items: Estabelecimento[]) => ({
        payload: { items },
      }),
    },
  },
});

export const estabelecimentoAction = estabelecimentoSlice.actions;

export default estabelecimentoSlice.reducer;

export const getEstabelecimentosSynced = (state: RootState) =>
  state.estabelecimento.items;
